module.exports = __webpack_public_path__ + "img/news-2.5573ed77.jpg";